<template>
  <a-tabs v-model:activeKey="searchForm.tab" style="background-color: #fff; padding: 0 12px" @change="getTableData()">
    <a-tab-pane key="-1" tab="全部收支"></a-tab-pane>
    <a-tab-pane key="1" tab="订单收支"></a-tab-pane>
    <a-tab-pane key="2" tab="订单外收支"></a-tab-pane>
  </a-tabs>

  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-group">
          <div class="group-one">
            <a-select v-model:value="searchForm.date_type" allowClear placeholder="日期类型" @change="getTableData">
              <a-select-option :value="1">记账日期</a-select-option>
              <a-select-option :value="2">结算日期</a-select-option>
              <a-select-option :value="3">创建日期</a-select-option>
            </a-select>
          </div>
          <div class="group-one" style="width: 220px">
            <a-range-picker v-model:value="rangePicker" :ranges="ranges" @change="handlePicker"/>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.type" allowClear placeholder="收支类型" @change="getTableData">
              <a-select-option :value="1">收入</a-select-option>
              <a-select-option :value="2">支出</a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.in_ids" :dropdownMatchSelectWidth="false" :maxTagCount="1"
                      mode="multiple"
                      placeholder="收入项目" @change="getTableData">
              <a-select-option v-for="(item, index) in searchList.income.list" :key="index" :value="item.id">{{
                  item.name
                }}
              </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.out_ids" :dropdownMatchSelectWidth="false" :max-tag-count="2"
                      mode="multiple"
                      placeholder="支出项目" @change="getTableData">
              <a-select-option v-for="(item, index) in searchList.inout.list" :key="index" :value="item.id">{{
                  item.name
                }}
              </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.source_id" :dropdownMatchSelectWidth="false" :max-tag-count="1"
                      :maxTagCount="1"
                      mode="multiple" placeholder="订单来源" @change="getTableData">
              <a-select-option v-for="(item, index) in searchList.source.list" :key="index" :value="item.id">{{
                  item.name
                }}
              </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.rids" :dropdownMatchSelectWidth="false" :filterOption="roomFilter"
                      :maxTagCount="1"
                      mode="multiple" placeholder="房型" @change="getTableData">
              <a-select-option v-for="(item, index) in searchList.room.list" :key="index" :value="item.id">{{
                  item.name
                }}
              </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.gids" :dropdownMatchSelectWidth="false" :filterOption="groupFilter"
                      :max-tag-count="1"
                      mode="multiple" placeholder="分组" @change="getTableData">
              <a-select-option v-for="(item, index) in searchList.group.list" :key="index" :value="item.id">{{
                  item.name
                }}
              </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.is_verify" allowClear placeholder="是否确认" @change="getTableData">
              <a-select-option :value="1">已确认</a-select-option>
              <a-select-option :value="2">待确认</a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.order_is_valid" allowClear placeholder="有效订单"
                      @change="getTableData">
              <a-select-option :value="1">有效</a-select-option>
              <a-select-option :value="2">无效</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="lef-one">
          <a-input-search v-model:value="searchForm.hname" :loading="searchLoading" allowClear
                          placeholder="房间名称|订单号" @search="getTableData">
          </a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
      <div class="bar-rig">
        <div class="rig-one">
          <a-button class="btn-primary" @click="openAddCost">记账</a-button>
        </div>
        <div class="rig-one">
          <a-button @click="updateSettleTime">按结算日期更新数据</a-button>
        </div>
        <div class="rig-one">
          <a-popover v-model:visible="visiblePopover" placement="bottom" trigger="click">
            <template #content>
              <template v-for="(item, index) in initColumns" :key="index">
                <div v-if="item.title !== '记账时间' && item.title" style="margin: 5px 0">
                  <a-checkbox v-model:checked="item.isShow">{{
                      item.title
                    }}
                  </a-checkbox>
                </div>
              </template>
              <a-button size="small" style="margin-right: 5px" @click="handleResetCheck">重置</a-button>
              <a-button class="btn-primary" size="small" @click="handleCheck">确认</a-button>
            </template>
            <a-button>
              <appstore-outlined/>
              视图
            </a-button>
          </a-popover>
        </div>
        <div class="rig-one">
          <a-button>
            <upload-outlined/>
            导出
          </a-button>
        </div>
      </div>
    </div>

    <!-- 统计 -->
    <div class="count">
      <span>总收入
        <span class="text f-c-red">{{
            countDate.income ? countDate.income : 0
          }}</span></span>
      <span class="bar">|</span>
      <span>总支出<span class="text f-c-green">{{
          countDate.expend ? countDate.expend : 0
        }}</span></span>
      <span class="bar">|</span>
      <span>净收入<span class="text f-c-red">{{
          countDate.profit ? countDate.profit : 0
        }}</span></span>
    </div>

    <!-- 表格 -->
    <a-table :columns="columns" :dataSource="dataSource" :loading="searchLoading" :pagination="false"
             :scroll="{ x: columns.length > 6 ? columns.length * 150 : 0, y: tableHeight }" bordered
             class="table" size="small">
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'cost_time'">
          <span v-if="searchForm.date_type == 3"> {{ record.create_time }} </span>
          <span v-if="searchForm.date_type == 1"> {{ record.cost_time }} </span>
          <span v-if="searchForm.date_type == 2"> {{ record.settlement_time > 0 ? record.settlement_time_str : '-' }}
          </span>
        </template>
        <template v-if="column.key == 'type'">
          <span v-if="record.type == 1" class="f-c-red"> 收入 </span>
          <span v-else-if="record.type == 2" class="f-c-green"> 支出 </span>
        </template>
        <template v-if="column.key == 'price'">
          <span v-if="record.type == 1" class="f-c-red"> {{ record.price }} </span>
          <span v-else-if="record.type == 2" class="f-c-green"> {{ record.price }} </span>
        </template>
        <template v-if="column.key == 'verify_time'">
          <span v-if="record.verify_time == 0"> - </span>
          <span v-else> {{ record.verify_time_str }} </span>
        </template>
        <template v-if="column.key == 'end_date'">
          <span v-if="record.order_id == 0"> - </span>
          <span v-else> {{ record.start_date }} - {{ record.end_date }} </span>
        </template>
        <template v-if="column.key == 'operate'">
          <a-button v-if="record.is_verify == 0" type="link" @click="handleEdit(record)">编辑</a-button>
          <a-button v-if="record.is_verify == 1" class="f-c-red" type="link"
                    @click="handleVerify(record, 2)">撤销确认
          </a-button>
          <a-button v-if="record.is_verify == 0" type="link" @click="handleVerify(record, 1)">确认账单</a-button>
          <a-button class="f-c-red" type="link" @click="handleDel(record)">删除</a-button>
        </template>
        <template v-if="column.key == 'settlement_time'">
          <span v-if="record.settlement > 0">{{ record.settlement_time_str }}</span>
          <span v-else>-</span>
        </template>
        <template v-if="column.key == 'order_no'">
          <a-button v-if="record.order_no" type="link" @click="openOrderDetails(record)">{{
              record.order_no
            }}
          </a-button>
          <div v-else>-</div>
        </template>
      </template>
    </a-table>

    <!-- 记账 -->
    <a-modal v-model:visible="addCostShow" title="记账" width="800px" @ok="handleAddAccount">
      <div class="addAccount">
        <a-form ref="accountRef" :label-col="{ span: 7 }" :model="accountForm"
                :rules="[{ required: true, message: '请选择类型' }]" labelAlign="left">
          <a-row justify="space-between" type="flex">
            <a-col :span="10">
              <a-form-item label="类型">
                <a-radio-group v-model:value="accountForm.type">
                  <a-radio value="1">收入</a-radio>
                  <a-radio value="2">支出</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item :rules="[{ required: true, message: '请选择类型' }]" label="项目" name="project">
                <a-select v-model:value="accountForm.project" placeholder="请选择项目" style="width: 100%">
                  <a-select-option v-for="item in accountForm.type == 1
                    ? searchList.income?.list
                    : searchList.inout?.list" v-show="accountForm.type == 1" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :rules="[{ required: true, message: '请输入金额' }]" label="金额" name="price">
                <a-input v-model:value="accountForm.price" :placeholder="accountForm.type == 1 ? '请输入收入金额' : '请输入支出金额'
                  " allowClear style="width: 100%"/>
              </a-form-item>
              <a-form-item :rules="[{ required: true, message: '请选择交易方式' }]" label="交易方式" name="mode">
                <a-select v-model:value="accountForm.mode" placeholder="请选择交易方式" style="width: 100%">
                  <a-select-option v-for="item in searchList.paytype?.list" :key="item.id" :value="item.id">{{
                      item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="相关房间" name="mode">
                <a-select v-model:value="accountForm.hid" allowClear placeholder="请选择房间(选填)" show-search
                          style="width: 100%" @click="handleGetHouseList">
                  <a-select-option v-for="(item, index) in houseList" :key="index" :value="item.id">{{
                      item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :rules="[{ required: true, message: '请选择时间' }]" label="记账时间" name="date">
                <a-date-picker v-model:value="costDate" placeholder="记账时间" show-time style="width: 100%"
                               @change="accountDateOk"/>
              </a-form-item>
            </a-col>
            <a-col :span="13">
              <a-form-item label="凭证" name="other">
                <div style="display: flex; flex-wrap: wrap">
                  <div v-for="(item, index) in accountForm.image" :key="index" class="image-box">
                    <a-image :height="102" :src="item.url" :width="102" alt="avatar">
                    </a-image>
                    <div class="del-box" @click="accountForm.image.splice(index, 1)"></div>
                  </div>
                  <a-upload v-model:file-list="accountForm.image" :action="action" :before-upload="beforeUpload"
                            :data="upLoadData"
                            :headers="upLoadHeader" :max-count="5" :show-upload-list="false"
                            list-type="picture-card" name="image" @change="upLoadChange($event, 'imageUrl')">
                    <div v-if="accountForm.image.length < 5">
                      <loading-outlined v-if="uploadLoading"></loading-outlined>
                      <plus-outlined v-else></plus-outlined>
                      <div class="ant-upload-text">上传凭证</div>
                    </div>
                  </a-upload>
                </div>
              </a-form-item>
              <a-form-item label="备注">
                <a-textarea v-model:value="accountForm.remark" :auto-size="{ minRows: 4 }" :maxlength="200" allowClear
                            placeholder="请输入备注(选填)" show-count/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
    <!-- 订单详情 -->
    <order-details v-model:visible="detShow" :orderId="orderId"/>

    <!-- 分页 -->
    <MyPagination :pageTotal="pageTotal" class="pagination" @onShowSizeChange="onShowSizeChange"
                  @pageChange="pageChange"/>
  </div>
</template>

<script>
import {createVNode, nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {
  addCost,
  costAlllist,
  costDel,
  detailsCost,
  editCost,
  getSearchList,
  houseSelectList,
  updateSettleTimeCost,
  verifyCost
} from "@/api/api";
import dayjs from "dayjs";
import {
  AppstoreOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index"; //VUEX
import {message, Modal} from "ant-design-vue";
import OrderDetails from "@/components/pms/landlord/OrderDetails/OrderDetails.vue";
import { baseRequestUrl } from "../../../../config.js";

export default {
  methods: {updateSettleTimeCost},
  components: {
    PlusOutlined, LoadingOutlined,
    UploadOutlined,
    AppstoreOutlined,
    OrderDetails,
  },
  setup() {
    let {countTable} = useUtils();

    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        date_type: 1,
        is_verify: [],
        order_is_valid: [],
        source_id: [],
        tab: -1,
        type: [],
        in_ids: [],
        out_ids: [],
        hname: "",
        ota_id: [],
        rids: [],
        gids: [],
        start_date: "",
        end_date: "",
        start: 0,
        limit: store.getters.getPageSize,
      },
      rangePicker: [],
      visiblePopover: false,
      ranges: {
        昨天: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
        今天: [dayjs(), dayjs()],
        明天: [dayjs().add(1, "day"), dayjs().add(1, "day")],
        最近7天: [dayjs().subtract(7, "day"), dayjs()],
        最近30天: [dayjs().subtract(30, "day"), dayjs()],
        上月: [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ],
        本月: [dayjs().startOf("month"), dayjs().endOf("month")],

        上季度: [
          dayjs().startOf("month").add(-1, "year").month(9),
          dayjs().endOf("month").add(-1, "year").month(11),
        ],
        本季度: [
          dayjs().startOf("month").month(0),
          dayjs().endOf("month").month(2),
        ],
      },
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
      },
      getSearchData() {
        if (!search.searchList.length) {
          getSearchList().then((res) => {
            search.searchList = res.data;
          });
        }
      },
      handlePicker(_params, value) {
        search.searchForm.start_date = value[0];
        search.searchForm.end_date = value[1];
        table.getTableData();
      },
      handleReset() {
        search.searchForm.hname = "";
        search.rangePicker = [];
        search.searchForm.ota_id = [];
        search.searchForm.gids = [];
        search.searchForm.rids = [];
        search.searchForm.in_ids = [];
        search.searchForm.out_ids = [];
        search.searchForm.type = [];
        search.searchForm.name = "";
        search.searchForm.start_date = "";
        search.searchForm.end_date = "";
        search.searchForm.source_id = [];
        search.searchForm.order_is_valid = [];
        search.searchForm.is_verify = [];
        table.getTableData();
      },
      handleCheck() {
        table.columns = table.initColumns.filter((item) => {
          return item.isShow;
        });
        search.visiblePopover = false;
      },
      handleResetCheck() {
        table.initColumns.map((item) => {
          item.isShow = true;
        });
        table.columns = JSON.parse(JSON.stringify(table.initColumns));
        search.visiblePopover = false;
      },
      groupFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      roomFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    const table = reactive({
      cloumd_title: '123',
      orderId: "",
      detShow: false,
      openOrderDetails(item) {
        table.orderId = item.order_id;
        table.detShow = true;
      },
      getTitle(id) {
        if (id == 1) {
          return '记账日期';
        } else if (id == 2) {
          return '结算日期';
        } else if (id == 3) {
          return '创建日期';
        }
      },
      tableHeight: "",
      dataSource: [],
      initColumns: [],
      countDate: {},
      columns: [
        {
          title: '日期',
          dataIndex: "cost_time",
          key: "cost_time",
          align: "center",
          width: 130,
          fixed: "left",
          isShow: true,
        },
        {
          title: "项目",
          dataIndex: "inout_name",
          key: "inout_name",
          align: "center",
          isShow: true,
          width: 100,
        },
        {
          title: "类型",
          dataIndex: "type",
          key: "type",
          align: "center",
          isShow: true,
          width: 100,
        },
        {
          title: "金额",
          dataIndex: "price",
          key: "price",
          align: "center",
          isShow: true,
          width: 100,
        },
        {
          title: "确认时间",
          dataIndex: "verify_time",
          key: "verify_time",
          align: "center",
          isShow: true,
          width: 130,
        },
        {
          title: "交易方式",
          dataIndex: "paytype_name",
          key: "paytype_name",
          align: "center",
          isShow: true,
          width: 100,
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          align: "center",
          isShow: true,
          width: 120,
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "入离日期",
          dataIndex: "end_date",
          key: "end_date",
          align: "center",
          isShow: true,
          width: 150,
        },
        {
          title: "订单渠道",
          dataIndex: "sname",
          key: "sname",
          align: "center",
          width: 100,
          isShow: true,
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "相关房间",
          dataIndex: "hname",
          key: "hname",
          align: "center",
          isShow: true,
          width: 100,
          ellipsis: true,
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          align: "center",
          isShow: true,
          width: 100,
          ellipsis: true,
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "操作人",
          dataIndex: "operate_name",
          key: "operate_name",
          align: "center",
          isShow: true,
          width: 100,
          ellipsis: true,
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "记账日期",
          dataIndex: "cost_time",
          key: "cost_time",
          align: "center",
          isShow: true,
          width: 130,
        },
        {
          title: "结账日期",
          dataIndex: "settlement_time",
          key: "settlement_time",
          align: "center",
          isShow: true,
          width: 130,
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          key: "create_time",
          align: "center",
          isShow: true,
          width: 130,
        },
        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
          align: "center",
          isShow: true,
          width: 160,
          fixed: "right",
        },
      ],
      getTableData() {
        search.searchLoading = true;
        costAlllist({
          tab: search.searchForm.tab,
          type:
              typeof search.searchForm.type == "number"
                  ? search.searchForm.type
                  : -1,
          hname: search.searchForm.hname,
          rids: search.searchForm.rids.toString(),
          gids: search.searchForm.gids.toString(),
          inout_ids: search.searchForm.in_ids
              .concat(search.searchForm.out_ids)
              .toString(),
          start_date: search.searchForm.start_date,
          end_date: search.searchForm.end_date,
          start: search.searchForm.start,
          limit: search.searchForm.limit,
          date_type: search.searchForm.date_type,
          is_verify: search.searchForm.is_verify,
          order_is_valid: search.searchForm.order_is_valid,
          source_id: search.searchForm.source_id.toString(),
        })
            .then((res) => {
              table.dataSource = res.data.list;
              table.countDate = res.data.statistics;
              pagination.pageTotal = res.data.count;
              table.initColumns = JSON.parse(JSON.stringify(table.columns));
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      // 修改账单
      handleEdit(item) {
        detailsCost({
          cost_id: item.id,
        }).then((res) => {
          cost.handleGetHouseList()
          cost.accountForm.isEdit = true;
          cost.accountForm.cost_id = res.data.id;
          cost.accountForm.order_id = res.data.order_id;
          cost.accountForm.type = res.data.type.toString();
          cost.accountForm.project = res.data.inout_id;
          cost.accountForm.mode = res.data.paytype_id;
          cost.accountForm.price = res.data.price;
          cost.accountForm.date = res.data.cost_time;
          cost.accountForm.remark = res.data.remark;
          cost.accountForm.image = res.data.get_image.length ? res.data.get_image.map(i => {
            return {url: i.image}
          }) : [];
          cost.accountForm.hid = [res.data.hid];
          cost.costDate = dayjs(res.data.date)
          cost.addCostShow = true;
        });
      },
      // 删除
      handleDel(item) {
        Modal.confirm({
          title:
              "收支信息删除后不可恢复，且会影响对应订单的收支信息，确定要删除吗？",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            costDel({cost_id: item.id}).then((res) => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
      // 确认账单操作
      handleVerify(item, op) {
        var title = '是否确认账单？';
        if (item.is_verify == 1) {
          title = '是否撤销账单确认？';
        }
        Modal.confirm({
          title: title,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            verifyCost({cost_id: item.id, op: op}).then((res) => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
    });

    const cost = reactive({
      costDate: "",
      addCostShow: false,
      accountRef: "",
      uploadLoading: false,
      houseList: [],
      accountForm: {
        cost_id: '',
        order_id: '',
        type: "1",
        project: [],
        price: "",
        mode: [],
        date: "",
        image: [],
        imageUrl: {},
        remark: "",
        hid: [],
      },
      //打开记账窗口
      openAddCost() {
        cost.accountForm = {
          cost_id: '',
          order_id: '',
          type: "1",
          project: [],
          price: "",
          mode: [],
          date: "",
          image: [],
          imageUrl: {},
          remark: "",
          hid: [],
        };
        cost.costDate = "";
        cost.addCostShow = true;
        nextTick(() => {
          cost.accountRef.clearValidate();
        })
      },
      //更新结算时间
      updateSettleTime() {
        Modal.confirm({
          title: '是否更新结算时间，订单按离店日期，其他按记账时间',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            updateSettleTimeCost({}).then((res) => {
              message.success(res.msg);
            });
          },
        });
      },
      // 记账 选择时间
      accountDateOk(v, s) {
        cost.accountForm.date = s;
      },
      // 上传图片钩子
      beforeUpload(file) {
        const isJpgOrPng =
            file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
          message.error("只能上传jpg、png格式图片!");
        }
        return isJpgOrPng;
      },
      // 上传图片回调
      upLoadChange(info, type) {
        if (info.file.status === "uploading") {
          cost.uploadLoading = true;
          return;
        }
        if (info.file.status === "done") {
          cost.accountForm[type] = info.file.response.data.url;
          cost.accountForm[type.slice(0, type.indexOf("Url"))] =
              info.fileList.map((item) => {
                return {
                  id: item.response ? item.response.data.id : item.id,
                  url: item.response ? item.response.data.url : item.url,
                };
              });
          cost.uploadLoading = false;
        }
        if (info.file.status === "error") {
          cost.uploadLoading = false;
          message.error("上传错误");
        }
      },
      // 上传图片
      action:
          baseRequestUrl + "/h5/upload/uploadImg?info=" +
          JSON.parse(sessionStorage.getItem("landlordInfo")).info,
      upLoadData: {
        module: "pms",
        type: "order",
      },
      upLoadHeader: {
        token: JSON.parse(sessionStorage.getItem("landlordInfo")).token,
        version: "1.0.0",
        source: "1",
      },
      //房间列表
      handleGetHouseList() {
        houseSelectList({}).then((res) => {
          cost.houseList = res.data;
        });
      },
      // filterOption (input, option){
      //   console.log(option);
      //   return option.value.indexOf(input) >= 0;
      // },
      // 记账
      handleAddAccount() {
        if (cost.accountForm.isEdit) {
          cost.accountRef.validate().then(() => {
            editCost({
              cost_id: cost.accountForm.cost_id,
              inout_id: cost.accountForm.project,
              paytype_id: cost.accountForm.mode,
              type: cost.accountForm.type,
              price: cost.accountForm.price,
              remark: cost.accountForm.remark,
              image: cost.accountForm.image.length
                  ? cost.accountForm.image.map(i => i.url).toString() : "",
              cost_time: cost.accountForm.date,
              hid: cost.accountForm.hid.toString(),
            }).then((res) => {
              message.success(res.msg);
              cost.accountRef.resetFields();
              cost.accountForm.date = "";
              cost.accountForm.remark = "";
              cost.addCostShow = false;
              table.getTableData();
            });
          });
        } else {
          cost.accountRef.validate().then(() => {
            addCost({
              inout_id: cost.accountForm.project,
              paytype_id: cost.accountForm.mode,
              type: cost.accountForm.type,
              price: cost.accountForm.price,
              remark: cost.accountForm.remark,
              image: cost.accountForm.image.length
                  ? cost.accountForm.image.map(i => i.url).toString() : "",
              cost_time: cost.accountForm.date,
              hid: cost.accountForm.hid.toString(),
            }).then((res) => {
              message.success(res.msg);
              cost.accountRef.resetFields();
              cost.accountForm.date = "";
              cost.accountForm.remark = "";
              cost.addCostShow = false;
              table.getTableData();
            });
          });
        }

      },
    })

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });
    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 120;
        }
    );

    onMounted(() => {
      search.getSearchData();
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 120;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      ...toRefs(cost),
    };
  },
};
</script>

<style lang="scss" scoped>
.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}

.count {
  display: flex;
  justify-content: center;
  margin: 10px;
  font-weight: bold;

  .bar {
    margin: 0 40px;
  }

  .text {
    margin-left: 5px;
  }
}
</style>
